import Header from 'components/header';
import Button from 'components/button';
import Loader from 'components/loader';
import ImageCarousel from 'components/image-carousel';
import BottomSheetError from 'components/bottom-sheet-error';
import BottomSheet, { BottomSheetProps } from 'components/bottom-sheet';

import useBoundStore from 'store';
import { formatAddress } from 'lib/utils';
import useBuilding from 'api/hooks/use-building';

import styles from './styles.module.scss';

type ComplexBottomSheetProps = { buildingId: number } & Pick<
  BottomSheetProps,
  'open' | 'onDismiss' | 'onSpringEnd'
>;

const BuildingBottomSheet: React.FC<ComplexBottomSheetProps> = (props) => {
  const { buildingId, onDismiss, ...rest } = props;

  const selectedSellBuilding = useBoundStore((s) => s.selectedSellBuilding);
  const setSelectedSellBuilding = useBoundStore((s) => s.setSelectedSellBuilding);

  const { building, error, isLoading } = useBuilding(buildingId);

  const handleToggleBuilding = (id: number, title: string) => () => {
    setSelectedSellBuilding({ id, title });
    onDismiss?.();
  };

  const address = building ? formatAddress(building) : '';

  return (
    <BottomSheet className={styles.bottomSheet} noPadding onDismiss={onDismiss} {...rest}>
      {isLoading ? (
        <Loader className={styles.loader} />
      ) : building ? (
        <>
          <ImageCarousel className={styles.carousel} images={building.images} isCarouselInDetails />
          <div className={styles.container}>
            <div className={styles.text}>
              <Header className={styles.header} text={building.title} />
              <p>
                <span className={styles.complexTitle}>
                  {building.apartmentComplex + (address ? ', ' : '')}
                </span>
                {address}
              </p>
            </div>
            <Button
              onClick={handleToggleBuilding(buildingId, building.title)}
              label={selectedSellBuilding.id === buildingId ? 'Отменить выбор' : 'Выбрать'}
            />
          </div>
        </>
      ) : (
        <BottomSheetError withButton onClick={onDismiss} message={error} />
      )}
    </BottomSheet>
  );
};

export default BuildingBottomSheet;
